import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconBlock from '../iconBlock/IconBlock';
import Carousel from '../carousel/Carousel';
import { useMediumUpBp } from '../../hooks/useMedia';

const IconBlocks = ({
  title,
  bio,
  customPadding,
  theme,
  colourScheme,
  direction,
  alignment,
  alignmentDesktop,
  alignItems,
  blocks,
  compact,
  titleSize,
  iconSize,
  slider,
  sectionId
}) => {
  const isMediumUp = useMediumUpBp();
  const componentClasses = classNames('icon-blocks', {
    [`icon-blocks--theme-${theme}`]: theme,
    [`icon-blocks--${colourScheme}`]: colourScheme,
    [`icon-blocks--${customPadding}`]: customPadding,
    [`icon-blocks--align-${alignment}`]: alignment,
    [`icon-blocks--align-desktop-${alignmentDesktop}`]: alignmentDesktop,
    'icon-blocks--compact': compact,
    'icon-blocks--slider': slider
  });

  const CarouselSlides = blocks.map((block, index) => (
    <IconBlock
      key={`${block.title}_${index}`}
      direction={direction}
      alignment={alignment}
      alignmentDesktop={alignmentDesktop}
      alignItems={alignItems}
      titleSize={titleSize}
      iconSize={iconSize}
      compact={compact}
      data={block}
    />
  ));

  return (
    <div className={componentClasses} id={sectionId}>
      {title && <h2 className="icon-blocks__title">{title}</h2>}
      {bio && <p className="icon-blocks__bio" dangerouslySetInnerHTML={{ __html: bio }}></p>}
      <div className="icon-blocks__container">
        {!isMediumUp && slider ? (
          <Carousel options={{ slidesToShow: 1, centerMode: true, centerPadding: '40px' }} slides={CarouselSlides} />
        ) : (
          CarouselSlides
        )}
      </div>
    </div>
  );
};

IconBlocks.propTypes = {
  title: PropTypes.string,
  bio: PropTypes.string,
  sectionId: PropTypes.string,
  colourScheme: PropTypes.oneOf(['light-grey', 'sand', 'neutral-navy', 'neutral-teal', 'dark-navy', 'white']),
  direction: PropTypes.oneOf(['horizontal']),
  alignment: PropTypes.oneOf(['left', 'center']),
  alignmentDesktop: PropTypes.oneOf(['center']),
  alignItems: PropTypes.oneOf(['top']),
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-top-bottom']),
  titleSize: PropTypes.oneOf(['medium', 'large']),
  iconSize: PropTypes.oneOf(['medium', 'large', 'x-large']),
  slider: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  compact: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  blocks: PropTypes.array.isRequired
};

export default IconBlocks;
